import React from "react";
import { Card } from "antd";

const VideoOverview = ({ videosData }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
      <Card className="rounded-2xl shadow-sm">
        <div className="text-4xl font-bold mb-2">
          {videosData?.data?.stats?.totalCount || 0}
        </div>
        <div className="text-gray-500">Total Video</div>
      </Card>
      <Card className="rounded-2xl shadow-sm">
        <div className="text-4xl font-bold mb-2">
          {videosData?.data?.stats?.associatedCount || 0}
        </div>
        <div className="text-gray-500">Associate to Organisations</div>
      </Card>
    </div>
  );
};

export default VideoOverview;
